import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const ShippingCompanies = ({ roles }) => {

    return (
        <M_Table entityName={'NavCompanies'} filtersOnTable rolePermissions={roles} />
    )
}